// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"dd31006766--tooltip--L1etT","content":"dd31006766--content--RKR4X"};